export default "__VITE_ASSET__DXNFh8oq__"